import React, { ReactElement } from 'react'
import { ILogementProps } from '../../interfaces/Logement'
import LocativeUpload from './LocativeUpload'

function Locative(props: ILogementProps): ReactElement {
  return <LocativeUpload {...props} />
}

export default Locative
